// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__VXAi_","obliqueLineWrap":"membershipbadge_obliqueLineWrap__tZF3C","obliqueLine":"membershipbadge_obliqueLine__DqfLu"};